module.exports = __webpack_public_path__ + "img/4.b0bd8da3.jpg";